/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { PeopleProfileShareEmail } from './peopleProfileShareEmail';
import type { PeopleProfilePhone } from './peopleProfilePhone';
import type { PeopleProfileWhatsapp } from './peopleProfileWhatsapp';
import type { PeopleProfileProfilePhotoBlobPath } from './peopleProfileProfilePhotoBlobPath';
import type { PeopleProfileFirstName } from './peopleProfileFirstName';

/**
 * People profile returned to the owner.
 */
export interface PeopleProfile {
  shareEmail?: PeopleProfileShareEmail;
  phone?: PeopleProfilePhone;
  whatsapp?: PeopleProfileWhatsapp;
  sharePhone?: boolean;
  shareWhatsapp?: boolean;
  showPhotoToConnections?: boolean;
  openToConnectGss?: boolean;
  profilePhotoBlobPath?: PeopleProfileProfilePhotoBlobPath;
  firstName?: PeopleProfileFirstName;
}
